import { BREAKPOINTS as _BREAKPOINTS } from './breakpoints.js'
import { GAME_ID } from '@config/game.js'
/* eslint-disable */

// ENVIRONMENT
export const ENV = __ENV__
export const PROD_DEVTOOLS = __VUE_PROD_DEVTOOLS__

export const REPLICATION_DELAY_MS = __REPLICATION_DELAY_MS__
export const API_RESULT_LIMIT = 100
export const ORIGIN = window.location.origin

// ENDPOINTS
export const PUBLIC_BASE_URL = `https://g-${GAME_ID}.modapi.io/v1`
export const SKETCHFAB_MODELS_ENDPOINT = 'https://api.sketchfab.com/v3/models'
export const AUTH_BASE_URL = __AUTH_BASE_URL__
export const LOGIN_REQUEST_CODE_ENDPOINT = `${AUTH_BASE_URL}/emailrequest`
export const LOGIN_EXCHANGE_CODE_ENDPOINT = `${AUTH_BASE_URL}/emailexchange`
export const LOGOUT_ENDPOINT = `${PUBLIC_BASE_URL}/oauth/logout`

// PLACEHOLDER IMAGES
export const CARD_IMAGE_KEY = 'thumb_320x180'
export const THUMBNAIL_IMAGE_KEY = 'thumb_128x128'

export const MODIO_LOGO_URL =
  'https://assets.modcdn.io/images/branding/modio-logo-bluewhite.svg'
export const LEGAL_AGE = 18
export const SCROLL_TO_ID = 'container'
export const NEW_RESOURCE_ID = 'new'
export const IMAGE_CROP_SIZES = [
  '50x50',
  '64x64',
  '100x100',
  '128x128',
  '256x256',
  '320x180',
  '640x360',
  '1280x720',
  '1020x2000',
]

// TODO: Move into language file once translations are supported
export const DEFAULT_ERROR_TITLE = 'Error'
export const DEFAULT_ERROR_MESSAGE =
  'An error has occurred please try again soon.'

// LOCALSTORAGE
export const LOCALSTORAGE_EXPIRE_DAYS = 2

// BREADCRUMB
export const BREADCRUMB_SEPARATOR = '/'

// PAGINATION
export const PAGINATION_LIMIT_OPTIONS = [
  { value: 30, text: '30/Page' },
  { value: 40, text: '40/Page' },
  { value: 50, text: '50/Page' },
]

export const PAGINATION_DEFAULT_PAGE = 1
export const PAGINATION_DEFAULT_TOTAL = 0
export const PAGINATION_DEFAULT_LIMIT = 30

// RATINGS
export const RATINGS_LIKE = 1
export const RATINGS_DISLIKE = -1
export const RATINGS_UNDECIDED = 0

// POLLING
export const POLL_SECONDS = 300
export const POLL_INTERVAL_SECONDS = 15
export const POLL_LOG = true

// TOAST
export const TOAST_SECONDS = 5

// ACTIVE ONLINE USER
export const ONLINE_USER_TIMEOUT_SECONDS = 600

// Use to redirect after icon animation completes
export const BUTTON_ANIMATION_DURATION = 2000
export const BUTTON_ICON_ANIMATION_DURATION = BUTTON_ANIMATION_DURATION - 500

// COMMENTS
export const MAX_DISCUSSION_LEVEL = 3
export const RECENT_GAME_COUNT = 5

// LOCALE
export const LOCALE_LANGUAGE = 'en-US'
export const LOCALE_TIMEZONE = 'America/Los_Angeles'

export const BREAKPOINTS = _BREAKPOINTS
export const PHP_UNIXTIME_LEN = 10

// NOTIFICATIONS
export const NOTIFICATION_COMMENT_REPLY_ON_OWNED_THREAD = 10
export const NOTIFICATION_TEAM_INVITE = 11
export const NOTIFICATION_TEAM_RESOURCE_PENDING = 12
export const NOTIFICATION_MOD_MODERATION = 13
export const NOTIFICATION_MOD_SUBSCRIBER = 14

// INLINE MEDIA LIBRARY
export const MEDIA_LIBRARY_MAX_FOLDERS = 4

export const CACHE_TIME_SECONDS = 60
export const MEDIA_LIBRARY_MAX_FOLDER_LENGTH = 8

export const IS_IOS_TOUCH_DEVICE =
  [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ].includes(navigator.platform) ||
  // iPad on iOS 13 detection
  (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
